import { Quotes } from "@phosphor-icons/react";

// Customer quotes the admin approved; hidden until there is at least one.
export const QuotesBlock = ({ quotes }) => {
  if (!quotes?.length) return null;
  return (
    <section data-testid="quotes-block" className="border-t border-[#2A2A2A]">
      <div className="mx-auto max-w-7xl px-6 py-20 md:py-24">
        <p className="font-mono text-xs text-[#00FF9D] mb-4">// FROM OUR EARLY CUSTOMERS</p>
        <h2 className="font-display text-3xl md:text-4xl font-semibold max-w-2xl">Founders who calibrated their runway.</h2>
        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {quotes.map((q, i) => (
            <figure key={i} data-testid={`quote-card-${i}`} className="rounded-2xl border border-[#2A2A2A] bg-[#121212] p-6 flex flex-col">
              <Quotes size={24} weight="fill" className="text-[#00FF9D]" />
              <blockquote className="mt-4 text-base leading-relaxed flex-1">“{q.quote}”</blockquote>
              <figcaption className="mt-6 text-sm">
                <span data-testid={`quote-name-${i}`} className="font-semibold">{q.name}</span>
                {q.role && <span data-testid={`quote-role-${i}`} className="block text-[#A3A3A3] text-xs mt-0.5">{q.role}</span>}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
